import { isTrainFeatureEnabled } from '@juvare/credentialing/ui/utils';
export function validateOccupationsCriteria(occupationGroup, occupations) {
    const hasOccupationGroup = !!(occupationGroup === null || occupationGroup === void 0 ? void 0 : occupationGroup.length);
    const hasOccupations = !!(occupations === null || occupations === void 0 ? void 0 : occupations.length);
    return {
        hasOccupationGroup,
        hasOccupations,
        hasGroupNoOccupations: hasOccupationGroup && !hasOccupations,
        hasOccupationsNoGroup: !hasOccupationGroup && hasOccupations,
    };
}
export function areQualificationsCriteriaMet(handler, userState) {
    const criteriaFields = ['skillIds', 'trainingIds', 'languageIds'];
    if (isTrainFeatureEnabled(userState)) {
        criteriaFields.push('trainCourseIds');
    }
    return criteriaFields.some((field) => {
        var _a;
        const data = (_a = handler.up().down(field)) === null || _a === void 0 ? void 0 : _a.getData();
        return !!(data === null || data === void 0 ? void 0 : data.length);
    });
}
export function validateQualificationsCriteria(handler, userState) {
    var _a, _b;
    const occupationGroupData = (_a = handler.up().down('groupId')) === null || _a === void 0 ? void 0 : _a.getData();
    const occupationData = (_b = handler.up().down('occupationIds')) === null || _b === void 0 ? void 0 : _b.getData();
    const qualificationsCriteriaAreMet = areQualificationsCriteriaMet(handler, userState);
    const { hasOccupationGroup, hasOccupations, hasOccupationsNoGroup, hasGroupNoOccupations } = validateOccupationsCriteria(occupationGroupData, occupationData);
    if (hasOccupationsNoGroup || hasGroupNoOccupations) {
        return undefined;
    }
    if (!qualificationsCriteriaAreMet && !hasOccupationGroup && !hasOccupations) {
        return 'At least one mission position criteria is required';
    }
    return undefined;
}
